import {
  ApiClientError,
  Folder,
  Presentation,
  Playlist,
  NewFileUploads,
} from '@raydiant/api-client-js';
import { useQueryClient } from 'react-query';
import raydiant from '../clients/raydiant';
import { keys } from '../queryClient';
import useProtectedMutation from './useProtectedMutation';

export default function useRenameContent() {
  const queryClient = useQueryClient();

  const mutation = useProtectedMutation<
    Folder | [Presentation, NewFileUploads] | Playlist,
    ApiClientError,
    { id: string; params: { name: string; resourceType: string } }
  >(
    async ({ id, params: { name, resourceType } }) => {
      if (resourceType === 'presentation') {
        try {
          const presentations = await raydiant.getPresentations({ ids: [id] });

          const presentation = presentations.find((pl) => pl.id === id);
          if (!presentation) {
            throw new Error('Cannot find presentation');
          }

          const nextPresentation = { ...presentation, name };

          return raydiant.updatePresentation(id, nextPresentation);
        } catch (error) {
          throw new Error(`Failed to fetch presentation: ${error}`);
        }
      }

      switch (resourceType) {
        case 'folder':
          return raydiant.updateFolder(id, { name });
        case 'playlist':
          return raydiant.updatePlaylist(id, { name });
        default:
          throw new Error(`Unknown resource type: ${resourceType}`);
      }
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(keys.library());
      },
    },
  );

  return mutation;
}
